import { c as _c } from "react/compiler-runtime";
import { useCurrentUser } from '@hooks/useCurrentUser';
import { doesUserHavePermission } from '@lib/utils/doesUserHavePermission';
import { isContactOnCall } from '@lib/utils/isContactOnCall';
import { useJotaiValue } from '@states/jotai/hooks';
import { contactSelector } from '@states/softphone/contactSelector';
import type { TPermission } from '@lib/types/generated/TPermission';
import type { TResourceStatus } from '@lib/types/generated/TResourceStatus';
export type TPermissionRequest = {
  key: TPermission;
  resourceStatus?: TResourceStatus;
};
export function useHasPermission(key: TPermission, resourceStatus?: TResourceStatus): boolean;
export function useHasPermission(...requests: TPermissionRequest[]): boolean[];
export function useHasPermission(...t0) {
  const $ = _c(6);
  const args = t0;
  const {
    user
  } = useCurrentUser();
  const contact = useJotaiValue(contactSelector);
  const isSingleCheck = typeof args[0] === "string";
  let t1;
  let t2;
  if ($[0] !== args || $[1] !== contact || $[2] !== isSingleCheck || $[3] !== user) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const requests = isSingleCheck ? [{
        key: args[0] as TPermission,
        resourceStatus: args[1] as TResourceStatus | undefined
      }] : args as TPermissionRequest[];
      if (user?.v2 == null) {
        t2 = isSingleCheck ? false : requests.map(_temp);
        break bb0;
      }
      const isOnCall = isContactOnCall(contact);
      t1 = requests.map(req => req != null && doesUserHavePermission(user.v2, req.key, {
        isOnCall,
        resourceStatus: req.resourceStatus
      }));
    }
    $[0] = args;
    $[1] = contact;
    $[2] = isSingleCheck;
    $[3] = user;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const results = t1;
  return isSingleCheck ? results[0] : results;
}
function _temp() {
  return false;
}